// src/components/pages/Pessoa/tabs/PessoaTabTelefones.jsx

import React from 'react';
import { ThemeProvider } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { Box, Button, Tooltip, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

import Input from '../../../form/Input';
import Select from '../../../form/Select';
import Checkbox from '../../../form/Checkbox';

import { usePessoaTelefoneModule } from '../modules/usePessoaTelefoneModule';
import { podeEditarItem, podeCancelarItem } from '../../../../hooks/usePermisionMRT';

const PessoaTabTelefones = ({ theme, module, mrt, EnumTipoTelefone }) => {
    const { items, rowCount, isLoading, isRefetching, isError, novoTelefone } = module.state;
    const { change, focus, blur, limpar, submit, handleEditarOuDeletar } = module.actions;
    const columns = module.columns;

    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Input
                    text="Novo Telefone"
                    type="text"
                    name="novoTelefone.numero"
                    placeholder="Número"
                    title="Digite o novo telefone da pessoa"
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoTelefone.numero || ''}
                />

                <Select
                    name="novoTelefone.tipo"
                    text="Tipo"
                    options={EnumTipoTelefone}
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoTelefone.tipo || 'Pessoal'}
                    isEnum={true}
                />

                <Checkbox
                    title="Quando marcado torna o telefone como principal da pessoa"
                    text="Principal"
                    name="novoTelefone.principal"
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoTelefone.principal}
                    checked={!!novoTelefone.principal}
                />

                <Checkbox
                    title="Víncula o número ao WhatsApp"
                    text="WhatsApp"
                    name="novoTelefone.zap"
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoTelefone.zap}
                    checked={!!novoTelefone.zap}
                />

                <Checkbox
                    title="Vincula o número ao Telegram"
                    text="Telegram"
                    name="novoTelefone.telegram"
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoTelefone.telegram}
                    checked={!!novoTelefone.telegram}
                />

                <Checkbox
                    title="Quando marcado torna o telefone ativo"
                    text="Ativo"
                    name="novoTelefone.ativo"
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoTelefone.ativo}
                    checked={!!novoTelefone.ativo}
                />

                <Button variant="contained" color="inherit" onClick={limpar} style={{ marginLeft: '10px' }}>
                    Limpar
                </Button>

                <Button
                    variant="contained"
                    color={String(novoTelefone.funcao).toLowerCase() === 'deletar' ? 'error' : 'info'}
                    disabled={!novoTelefone.numero}
                    onClick={submit}
                    style={{ marginLeft: '5px' }}
                >
                    {novoTelefone.funcao}
                </Button>
            </Box>

            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: { align: 'center' },
                            size: 100,
                        },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true,
                            enableResizing: true,
                            muiTableHeadCellProps: { sx: { fontSize: '1.2rem' } },
                        },
                        'mrt-row-select': {
                            enableColumnActions: false,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="left" title="Editar">
                                <span>
                                    <IconButton
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Editar')}
                                        disabled={!podeEditarItem()}
                                    >
                                        <Edit />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Deletar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Deletar')}
                                        disabled={!podeCancelarItem()}
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    columns={columns}
                    data={items}
                    rowCount={rowCount}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data' } : undefined}
                    onColumnFiltersChange={mrt.setColumnFilters}
                    onColumnFilterFnsChange={mrt.setColumnFiltersMode}
                    onGlobalFilterChange={mrt.setGlobalFilter}
                    onPaginationChange={mrt.setPagination}
                    onSortingChange={mrt.setSorting}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                    }}
                    state={{
                        columnFilterFns: mrt.columnFilterFns,
                        columnFilters: mrt.columnFilters,
                        globalFilter: mrt.globalFilter,
                        isLoading,
                        pagination: mrt.pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting: mrt.sorting,
                    }}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};

export default React.memo(PessoaTabTelefones);
